/*
 * A future joiner: someone who hasn't joined MPG yet, so profiles can be
 * made for them before HiBob creates their Person (crud/future_joiner.py).
 * Their `fj-<uuid>` id stands in for a person_id on the profile sets, CV
 * uploads and Profile → Projects entries they own. Never in People.
 */
export type FutureJoinerStatus = 'prospect' | 'offer_accepted' | 'not_proceeding';

export const FUTURE_JOINER_STATUS_LABELS: Record<FutureJoinerStatus, string> = {
  prospect: 'Prospect',
  offer_accepted: 'Offer accepted',
  not_proceeding: 'Not proceeding',
};

export interface FutureJoinerSkill {
  skill_id: string;
  proficiency: 1 | 2 | 3;
}

export interface FutureJoiner {
  id: string;
  first_name: string;
  last_name?: string;
  role?: string; // the job title they're joining as
  city?: string;
  country?: string;
  timezone_name?: string;
  expected_start_date?: string | null; // YYYY-MM-DD
  status: FutureJoinerStatus;
  notes?: string;
  profile?: string; // Profile Summary (plain text)
  skills: FutureJoinerSkill[];
  created_at?: string;
  created_by_email?: string;
  updated_at?: string;
}

export const isFutureJoinerId = (id?: string | null) => !!id && id.startsWith('fj-');

export const futureJoinerName = (fj: Pick<FutureJoiner, 'first_name' | 'last_name'>) => (
  [fj.first_name, fj.last_name].filter(Boolean).join(' ')
);

// Where a person id's page lives: future joiners have their own record page.
export const personPagePath = (id: string) => (isFutureJoinerId(id)
  ? `/future-joiners/details?id=${id}`
  : `/people/details?personId=${id}`);
